import BotonVerArchivoComponent from "./BotonVerArchivoComponent"
import React, { useState, Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
// import estilo from './TablaProducto.module.css';
import { v4 as uuidv4 } from 'uuid';
import Tooltip from '@mui/material/Tooltip';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { Paper, Typography } from '@mui/material';
import estilo from './TablaDocumentacion.module.css'
import moment from 'moment'
const styleIncorrecto = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(100%, -10%)',
    width: 330,
    height: 220,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 0,
    p: 3,
    'overflowY': 'scroll',
};
const styleCorrecto = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(90%, -35%)',
    width: 350,
    height: 450,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 3,
    p: 3,
    // background:'black',
    opacity: 1,
    'overflowY': 'scroll',
};
function TablaDocumentacion(props) {
    const { api = undefined } = props
    const { handdleEditPrev } = api
    let rows = props.rows
    //const modoVerDetalle = false
    const modoVerDetalle = useSelector(store => store.FC_30SolicitudAtencionACliente.modoVerDetalle)
    const columnsDocumentacion = [
        {
            field: 'nameDoc', headerName: 'Documentación', headerClassName: estilo.headerSolicitudes, headerAlign: 'center', flex:1, sortable: false,
            renderCell: (params) =>
            (
                <Fragment>
                    {
                        params.row.tabla ?
                            <div>
                                <label >{`${params.row.nameDoc}`}</label>
                            </div>
                            :
                            <div className='col-md-12'>
                                <label className={`${estilo.divisionDocumentacion}`}>{`${params.row.nameDoc}`}</label>
                            </div>
                    }
                </Fragment>
            )
        },
        {
            field: 'archivo', headerName: 'Archivo', headerClassName: estilo.headerSolicitudes, headerAlign: 'center', flex:.1, sortable: false,
            renderCell: (params) =>
            (
                <Fragment>
                    {
                        params.row.tabla &&
                        <BotonVerArchivoComponent tabla={params.row?.tabla} nombreId={params.row?.nombreId} idSolicitud={params.row?.idSolicitud} nameid={params.row?.nameid} />
                    }
                </Fragment>
            )
        },
        {
            field: 'accion', headerName: 'Acción', headerClassName: estilo.headerSolicitudes, headerAlign: 'center', flex:.2, sortable: false,
            renderCell: (params) =>
            (
                <Fragment>
                    {
                        params.row.tabla &&
                        <>
                            <button className={params.row.correcto ? ('btn btn-success') : ('btn btn-outline-success')} onClick={() => handleOpenModalCorrecto(params)}>✓</button>
                            <button className={params.row.incorrecto ? ('btn btn-danger ms-3') : ('btn btn-outline-danger ms-3')} onClick={() => handleOpenModalIncorrecto(params)}>X</button>
                        </>
                    }
                </Fragment>
            )
        },
    ]

    const [campo, setCampo] = React.useState('')
    const [valor, setValor] = React.useState('')
    const [observaciones, setObservaciones] = React.useState('')
    const [correcto, setCorrecto] = React.useState('')
    const [incorrecto, setIncorrecto] = React.useState('')
    const [id, setId] = React.useState('')
    const [rowSeleccionada, setRowSeleccionada] = React.useState(false)
    const [openModalCorrecto, setOpenModalCorrecto] = React.useState(false);
    const [documentacion, setDocumentacion] = React.useState('')
    const [estadoVigencia, setEstadoVigencia] = React.useState('')
    const [fechaInicio, setFechaInicio] = React.useState('')
    const [fechaTermino, setFechaTermino] = React.useState('')

    const handleOpenModalCorrecto = (params) => {
        setDocumentacion(params.row.documentacion)
        setId(params.row.id)
        setCorrecto(true)
        setIncorrecto(false)
        setCampo(params.row.Campo)
        setObservaciones(params.row.observaciones)
        setOpenModalCorrecto(true)
        setValor(params.row.valor)
        setFechaInicio((params.row.fechaInicio !== null && params.row.fechaInicio !== '') ? (params.row.fechaInicio) : '')
        setFechaTermino((params.row.fechaTermino !== null && params.row.fechaTermino !== '') ? (params.row.fechaTermino) : '')
        setEstadoVigencia((params.row.estatus !== null && params.row.estatus !== undefined) ? params.row.estatus : 'Agregar')
        if (params.row.tabla) {
            setRowSeleccionada(true)
            setValor(params.row.nameDoc)
        }
    }

    const handleCloseModalCorrecto = () => {
        setFechaInicio('')
        setFechaTermino('')
        setEstadoVigencia('')
        setOpenModalCorrecto(false)
        setVigencia(false)
        setRowSeleccionada(false)
    }
    const [vigencia, setVigencia] = React.useState(false);
    const botonVigencia = () => {
        setVigencia(true)
    }
    const botonCerrarVigencia = () => {
        obtenerVigencia()
        setVigencia(false)
    }
    const obtenerVigencia = () => {

        let bandera = false
        let fecha1 = new Date(fechaTermino)
        let fecha2 = new Date(moment().format('YYYY-MM-DD'))

        let milisegundosDia = 24 * 60 * 60 * 1000
        let milisegundosTrascurridos = Math.abs(fecha1.getTime() - fecha2.getTime())
        let diasTranscurridos = Math.round(milisegundosTrascurridos / milisegundosDia)
        let milisegundos = fecha1.getTime() - fecha2.getTime()
        if (milisegundos > 0) {
            setEstadoVigencia('Vigente')
        } else {
            setEstadoVigencia('Vencido')
        }
        return bandera
    }
    const modalComponentCorrecto = () => {
        return (
            <div>
                <Modal
                    open={openModalCorrecto}
                    onClose={handleCloseModalCorrecto}
                    hideBackdrop={true}

                >
                    <Box sx={styleCorrecto}>
                        <Typography id="modal-modal-description" component="h2" sx={{ color: 'black' }}>
                            {campo == 'Tipo de inscripción' ?
                                <div className="row">
                                    <div className='col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 text-center'>
                                        <input className={`form-check-input me-1 escalar `}
                                            type="checkbox"
                                            onChange={e => cambioCliente(e)}
                                            checked={asociado} id="asociado"
                                            name="asociado"
                                        />
                                        <label className="form-check-label me-1" htmlFor="flexCheckChecked">
                                            Asociado
                                        </label>
                                    </div>
                                    <div className='col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 text-center'>
                                        <input className={`form-check-input me-1 escalar `}
                                            type="checkbox"
                                            onChange={e => cambioCliente(e)}
                                            checked={noasociado} id="noasociado"
                                            name="noasociado"
                                        />
                                        <label className="form-check-label me-1" htmlFor="flexCheckChecked">
                                            No asociado
                                        </label>
                                    </div>
                                    <div className='col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 text-center'>
                                        <input className={`form-check-input me-1 escalar `}
                                            type="checkbox"
                                            onChange={e => cambioCliente(e)}
                                            checked={inscrito} id="inscrito"
                                            name="inscrito"
                                        />
                                        <label className="form-check-label me-1" htmlFor="flexCheckChecked">
                                            Inscrito
                                        </label>
                                    </div>
                                    {
                                        inscrito &&
                                        <div className="form-floating mb-3" color='black'>
                                            <textarea className="form-control" id="exampleFormControlTextarea1" rows="3" style={{ height: "50px" }} value={numerosocio} onChange={e => setnumerosocio(e.target.value)} disabled={modoVerDetalle} />
                                            <label htmlFor="floatingInput">Número de socio</label>
                                        </div>
                                    }

                                </div>
                                :
                                <div className="form-floating mb-3" color='black'>
                                    <textarea className="form-control" id="exampleFormControlTextarea1" rows="3" style={{ height: "80px" }} value={valor} onChange={e => setValor(e.target.value)} disabled={modoVerDetalle} />
                                    {/* <input type="text" className={`form-control `} id="floatinginput" placeholder='Campo' value={valor} onChange={e => setValor(e.target.value)} /> */}
                                    <label htmlFor="floatingInput">Campo</label>
                                </div>
                            }

                            <div className="form-floating mb-3">
                                <textarea className="form-control" id="exampleFormControlTextarea1" rows="3" value={observaciones} onChange={e => setObservaciones(e.target.value)} disabled={modoVerDetalle}></textarea>
                                <label htmlFor="floatingInput">Observaciones</label>
                            </div>
                            <br /><br />
                            <>
                                <label htmlFor="floatingInput">Vigencia: </label>
                                <button className={
                                    (estadoVigencia === '' || estadoVigencia === 'Agregar') ? (
                                        `${estilo.agregarVigencia} btn ms-3`
                                    ) : estadoVigencia === 'Vigente' ? (
                                        'btn btn-success ms-3'
                                    ) : 'btn btn-danger ms-3'
                                } onClick={() => { botonVigencia() }} disabled={modoVerDetalle}>{`${estadoVigencia}`}</button><br />
                            </>
                            {
                                vigencia &&
                                <>
                                    <br />
                                    <div className='row justify-content-center'>
                                        <div className="form-floating col-md-6">
                                            <input type="date" className={`form-control `} id="floatinginput" placeholder='Inicio'
                                                value={fechaInicio} onChange={e => setFechaInicio(e.target.value)} />
                                            <label htmlFor="floatingInput"> Fecha inicio</label>
                                        </div>
                                        <div className="form-floating col-md-6">
                                            <input type="date" className={`form-control `} id="floatinginput" placeholder='Termino'
                                                value={fechaTermino} onChange={e => setFechaTermino(e.target.value)} />
                                            <label htmlFor="floatingInput">Fecha termino</label>

                                        </div>
                                        <div className=" text-center" >
                                            <br />
                                            <button className='btn btn-warning' onClick={() => { botonCerrarVigencia() }}>Establecer</button>
                                        </div>
                                    </div>
                                </>
                            }<br />
                        </Typography>
                        <br />
                        {modoVerDetalle ?
                            <div className='row'>
                                <div className={` text-center`}>
                                    <button className='btn btn-outline-danger' onClick={() => { handleCloseModalCorrecto() }}>CERRAR</button>
                                </div>
                            </div>
                            :
                            <div className='row col-md-12'>
                                <div className='col-md-6'>
                                    <button className='btn btn-outline-success' onClick={() => { botonGuardar() }}>GUARDAR</button>
                                </div>
                                <div className={`col-md-6`}>
                                    <button className='btn btn-outline-danger' onClick={() => { handleCloseModalCorrecto() }}>CANCELAR</button>
                                </div>
                            </div>
                        }
                    </Box>
                </Modal>
            </div >
        )
    }
    const [openModalIncorrecto, setOpenModalIncorrecto] = React.useState(false);
    const handleOpenModalIncorrecto = (params) => {
        setId(params.row.id)
        setIncorrecto(true)
        setCorrecto(false)
        setCampo(params.row.Campo)
        setValor(params.row.valor)
        setObservaciones(params.row.observaciones)
        setOpenModalIncorrecto(true)
    }
    const handleCloseModalIncorrecto = () => {
        setOpenModalIncorrecto(false)

    }
    const modalComponentIncorrecto = () => {
        return (
            <div>
                <Modal
                    open={openModalIncorrecto}
                    onClose={handleCloseModalIncorrecto}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    hideBackdrop={true}
                >
                    <Box sx={styleIncorrecto}>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 0 }} className='text-center'>
                            <label className='text-center'>Observaciones</label>
                            <textarea className="form-control" id="exampleFormControlTextarea1" rows="3"
                                value={observaciones} onChange={e => setObservaciones(e.target.value)}></textarea>
                        </Typography>
                        <br />
                        
                        {modoVerDetalle ?
                            <div className='row'>
                                <div className={` text-center`}>
                                    <button className='btn btn-outline-danger' onClick={() => { handleCloseModalIncorrecto() }}>CERRAR</button>
                                </div>
                            </div>
                            :
                            <div className='row'>
                            <div className='col-md-6'>
                                <button className='btn btn-outline-success' onClick={() => { botonGuardar() }}>GUARDAR</button>
                            </div>
                            <div className={` col-md-6`}>
                                <button className='btn btn-outline-danger' onClick={() => { handleCloseModalIncorrecto() }}>CANCELAR</button>
                            </div>
                        </div>
                        }
                    </Box>
                </Modal>
            </div>
        )
    }
    const botonGuardar = () => {
        let datos = {
            id: id, campo: campo, correcto: correcto, incorrecto: incorrecto, observaciones: observaciones,
            fechaInicio: fechaInicio, fechaTermino: fechaTermino, estatus:estadoVigencia
        }
        handdleEditPrev(datos)
        handleCloseModalCorrecto(true)
        handleCloseModalIncorrecto(true)
    }
    const obtenerAncho = () => {
        const anchoPantalla = window.innerWidth
        return anchoPantalla
    }
    return (
        <div className='container'>
            <div className='col-12 mt-1 ms-0 text-center'>
                <div style={{ height: (130 + (rows.length * 50)), width:  '100%', color: 'black' }}>
                    <DataGrid
                        rows={rows}
                        columns={columnsDocumentacion}
                        rowsPerPageOptions={[50]}
                        sx={{
                            boxShadow: 0,
                            color: 'black',
                            border: 0,
                            // '& .MuiDataGrid-cell': {
                            //     display: 'block',
                            //     position: 'relative',
                            //     textAlign: 'center',
                            // },
                        }}
                    />
                </div>
            </div>
            {modalComponentCorrecto()}
            {modalComponentIncorrecto()}
        </div >
    )

}
export default TablaDocumentacion